/**
 * Transcoded origin value used by kenobiService
 */
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum OriginCode {
    HP = 'HP',
    OEM = 'OMOI',
    NEC = 'ECLIENT',
    ECQ = 'ECLIENT',
    SMS = 'SMSSUIVO',
    AEL = 'AEL',
    SOSH = 'SOSH',
    SMSSOSH = 'SMSSUIVS',
    MYSSOSH = 'MYSOSH',
    MLB = 'MLB',
    DIAG = 'CRM',
    PATH = 'CRM',
    SPAS = 'CRM',
    POCD = 'CRM',
}
